<div class="login-page" id="appLogin">
  <small class="debug">{{me}}</small>
  <br/>
  <div>
    @switch (m_currentViewMode) {
      @case (m_viewMod.CREATE) {
        <div>
          <app-login (createAccountEvent)="onSubmit($event)" [setMode]="'CREATE_ACCOUNT'"></app-login>
          <!--            <a mat-button class="pull-left" routerLink="/getstarted/pick">-->
          <a mat-button class="pull-left" (click)="goBack()">
            <small class="debug"> {{me}} </small>
            <mat-icon>keyboard_arrow_left</mat-icon>
            {{'account.back' | transloco}}
          </a>
        </div>
      }
      @case (m_viewMod.LOADING) {
        <div class="loadingWrap">
          <div fxLayout="column" fxLayoutAlign="center center">
            <mat-spinner [strokeWidth]="0.5"></mat-spinner>
          </div>
        </div>
      }
    }
  </div>
</div>



<!--            <form [@fadeIn]="" class="form-signin cahnge-pwd-form" (ngSubmit)="onSubmit()" name="passwordForm" [formGroup]="accountForm" #formDir="ngForm">-->
<!--                <div class="homeLink" (click)="openHome()">-->
<!--                    <img src="assets/images/DSLogo.png"/>-->
<!--                    <br/>-->
<!--                    <mat-label style="font-size: 10px; color: #505050">{{'account.freeSignage' | transloco}}</mat-label>-->
<!--                </div>-->
<!--                <ul>-->
<!--                    <div>-->
<!--                        <h2 class="form-signin-heading"></h2>-->
<!--                        <input *ngIf="!socialMode" formControlName="business" name="business" class="input-underline passField input-lg form-control" placeholder="{{'account.businessName' | transloco}}">-->
<!--                        <input formControlName="user" name="user" class="input-underline passField input-lg form-control" placeholder="{{'account.fullName' | transloco}}" required>-->
<!--                        <mat-error *ngIf="(user.dirty || user.touched) && user.invalid"><br/>{{'account.longerUser' | transloco}}</mat-error>-->
<!--                        <br/>-->
<!--                        <input formControlName="email" name="email" class="input-underline passField input-lg form-control" placeholder="{{'account.emailAddress' | transloco}}" required>-->
<!--                        <mat-error *ngIf="(email.dirty || email.touched) && email.invalid"><br/>{{'account.emailRequired' | transloco}}</mat-error>-->
<!--                        <mat-error *ngIf="(email.dirty || email.touched) && email.invalid">{{'account.valueValidEmail' | transloco}}</mat-error>-->
<!--                        <br/>-->
<!--                        <div *ngIf="!socialMode">-->
<!--                            <input class="input-underline passField input-lg form-control" name="password" placeholder="{{'account.password' | transloco}}" type="password" formControlName="password" required>-->
<!--                            <mat-error *ngIf="password.invalid && (password.dirty || password.touched || isSubmit)">-->
<!--                            <span *ngIf="password.errors.required">-->
<!--                                  <br/>{{'account.enterPassword' | transloco}}-->
<!--                            </span>-->
<!--                                <span *ngIf="password.errors.maxlength">{{'account.emailMoreChar' | transloco}}</span>-->
<!--                                <span *ngIf="password.errors.minlength"><br/>-->
<!--                                    {{'account.longerEmailRequired' | transloco}}-->
<!--                            </span>-->
<!--                            </mat-error>-->
<!--                            <input class="input-underline passField input-lg form-control" name="password" placeholder="{{'account.confirmPassword' | transloco}}" type="password" formControlName="confirm_password" required>-->
<!--                            &lt;!&ndash;  <mat-icon matSuffix (click)="confirm_hide = !confirm_hide">{{confirm_hide ? 'visibility_off' : 'visibility'}}</mat-icon>&ndash;&gt;-->
<!--                            <mat-error *ngIf="(confirm_password.invalid && (confirm_password.dirty || confirm_password.touched || isSubmit) || accountForm.errors?.mismatch)">-->
<!--                        <span *ngIf="confirm_password.errors || accountForm.errors?.mismatch">-->
<!--                          <br/>-->
<!--                          {{'account.passwordMismatch' | transloco}}-->
<!--                          <br/>-->
<!--                        </span>-->
<!--                            </mat-error>-->
<!--                        </div>-->
<!--                        <div fxLayout='row' fxLayoutGap="10px">-->
<!--                        </div>-->
<!--                        <br/>-->
<!--                        <div>-->
<!--                            <button *ngIf="!socialMode" type="submit" style="background: var(&#45;&#45;background-button1); color: var(&#45;&#45;text-color6); width: 210px" mat-stroked-button color="primary">-->
<!--                                {{'account.continue' | transloco}}-->
<!--                                <fa-icon style="font-size: 1.3em" class="pull-right" [icon]="faSignInAlt"></fa-icon>-->
<!--                            </button>-->
<!--                            <div *ngIf="!this.socialMode">-->
<!--&lt;!&ndash;                                <div style="padding: 15px">&ndash;&gt;-->
<!--&lt;!&ndash;                                    {{'account.or' | transloco}}&ndash;&gt;-->
<!--&lt;!&ndash;                                </div>&ndash;&gt;-->
<!--                                <div style="padding: 4px"></div>-->
<!--                                <button type="button" (click)="onLoginAmazonPopup($event)" style="background: #fbc931; color: black; width: 210px" mat-stroked-button color="primary">{{'account.loginWithAmazon' | transloco}}-->
<!--                                    <fa-icon style="color: black; font-size: 1.3em" class="pull-right" [icon]="faAmazon"></fa-icon>-->
<!--                                </button>-->
<!--                                <div style="padding: 4px"></div>-->
<!--                                <button style="background: var(&#45;&#45;background-button2); color: #ffffff; width: 210px" type="button" (click)="signInWithFB()" mat-stroked-button>-->
<!--                                    {{'account.loginWithFB' | transloco}}-->
<!--                                    <fa-icon style="color: white; font-size: 1.3em" class="pull-right" [icon]="faFacebook"></fa-icon>-->
<!--                                </button>-->
<!--&lt;!&ndash;                                <div style="padding: 15px">&ndash;&gt;-->
<!--&lt;!&ndash;                                    {{'account.or' | transloco}}&ndash;&gt;-->
<!--&lt;!&ndash;                                </div>&ndash;&gt;-->
<!--                                <div style="padding: 4px"></div>-->
<!--                                <button style="background: #df4a32; color: white; width: 210px" type="button" (click)="signInWithGoogle()" mat-stroked-button>-->
<!--                                    {{'account.loginWithGL' | transloco}}-->
<!--                                    <fa-icon style="color: white; font-size: 1.3em" class="pull-right" [icon]="faGoogle"></fa-icon>-->
<!--                                </button>-->
<!--                            </div>-->
<!--                            <br/>-->
<!--                            <br/>-->
<!--                        </div>-->
<!--                        <a mat-button class="pull-left" routerLink="/getstarted/pick">-->
<!--                            <mat-icon style="position: relative; top: -2px">keyboard_arrow_left</mat-icon>-->
<!--                            {{'account.back' | transloco}}-->
<!--                        </a>-->
<!--                        <div class="clearFloat"></div>-->
<!--                        <br/>-->
<!--                        <mat-divider></mat-divider>-->
<!--                    </div>-->
<!--                </ul>-->
<!--            </form>-->
